import React from 'react';
import HelpButton from './HelpButton';

class HelpLabel extends React.Component {

  render() {
    let lclass = 'helpLabel';
    const hint = this.props.hint;
    const text = this.props.text;
    if (this.props.inline === true) { lclass = 'helpLabelInline'}

    return(
      <label className={lclass}>{text} <HelpButton hint={hint}/></label>
    )
  }

}

export default HelpLabel;